import { Link } from 'react-router-dom'
import { Reveal } from '../../../components/Reveal.jsx'
import { IconCheck } from '../../../components/Icons.jsx'
import { INTAKE_PATH } from '../constants/links.js'

const steps = [
  {
    t: 'Complete Your Health Intake',
    b: 'Answer a comprehensive health questionnaire online. Takes 5 minutes. No phone calls, no waiting rooms.',
  },
  {
    t: 'Provider Review & Lab Order',
    b: 'A board-certified provider reviews your history, orders labs if needed, and builds a protocol specific to your goals.',
  },
  {
    t: 'Prescription Shipped to You',
    b: 'Your compounded medication is dispensed by our 503A pharmacy partner and shipped directly to your door — with ongoing support built in.',
    badge: '7–10 days',
  },
]

export function HowItWorks() {
  return (
    <section id="how" className="bg-[#EDF7F7] py-[104px] max-[640px]:py-14">
      <div className="hb-wrap grid grid-cols-1 gap-12 max-[640px]:gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <Reveal>
            <p className="font-display text-[12px] font-extrabold uppercase tracking-[2.5px] text-teal-700">
              How it works
            </p>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="mt-4 font-serif text-[clamp(32px,4.2vw,44px)] font-semibold leading-[1.08] tracking-[-0.5px] text-[#191A17]">
              From intake to treatment{' '}
              <em className="hl text-teal-600">in as little as 7–10 days.</em>
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-5 text-[16px] leading-[1.7] text-[#4A4A4A] max-[640px]:mt-3 max-[640px]:text-[15px]">
              Provider-guided care, online. We make the path from intake to treatment as direct as
              possible — and stay with you the whole way.
            </p>
          </Reveal>
          <Reveal delay={200}>
            <div className="mt-7 max-[640px]:mt-5">
              <Link to={INTAKE_PATH} className="btn btn-berry btn-lg">
                Start My Visit
              </Link>
            </div>
          </Reveal>
          <Reveal delay={260}>
            <div className="mt-8 grid grid-cols-2 gap-4 max-[640px]:mt-5 max-[640px]:gap-3">
              <div className="rounded-2xl border border-[#008080]/10 bg-white p-5 max-[640px]:p-4">
                <div className="text-[12px] font-bold uppercase tracking-[0.12em] text-stone-600">
                  Intake
                </div>
                <div className="mt-1 text-[22px] font-extrabold text-[#1A1A1A] max-[640px]:text-[18px]">5 minutes</div>
              </div>
              <div className="rounded-2xl border border-[#008080]/10 bg-white p-5 max-[640px]:p-4">
                <div className="text-[12px] font-bold uppercase tracking-[0.12em] text-stone-600">
                  To treatment
                </div>
                <div className="mt-1 text-[22px] font-extrabold text-[#1A1A1A] max-[640px]:text-[18px]">7–10 days</div>
              </div>
            </div>
          </Reveal>
        </div>

        <ol className="space-y-10 max-[640px]:space-y-7">
          {steps.map((s, i) => (
            <Reveal as="li" key={s.t} delay={i * 60} className="group relative pl-16">
              <span
                aria-hidden
                className="pointer-events-none absolute -left-2 -top-8 select-none font-display text-[7rem] font-black leading-none text-[#008080]/10"
              >
                {i + 1}
              </span>
              <span className="absolute left-0 top-2 flex h-9 w-9 items-center justify-center rounded-full border-2 border-[#008080]/20 bg-white text-[#008080]/50 transition-colors group-hover:border-[#008080] group-hover:bg-[#008080] group-hover:text-white">
                <IconCheck size={16} />
              </span>
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="text-[20px] font-extrabold text-[#1A1A1A] transition-colors group-hover:text-[#008080]">
                  {s.t}
                </h3>
                {s.badge && (
                  <span className="rounded-full bg-[#721A55]/10 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-[#721A55]">
                    {s.badge}
                  </span>
                )}
              </div>
              <p className="mt-2 max-w-[520px] text-[15px] leading-[1.7] text-stone-700">{s.b}</p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  )
}
